import { Card, Row, Typography } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../assets/icons/arrow-up.svg';
import ProposalService from '../../services/ProposalService';
import { formatToTRY } from '../../utils';

const { Text, Title } = Typography;

const EarningsPerTransactionCard = () => {
  const [counts, setCounts] = useState<any>()
  const [reneuw, setRenuew] = useState<any>({})

  const getRenewSummary = useCallback(async () => {
    try {
      let response: any = await ProposalService.getDocuments();
      setCounts(response.data)
    } catch (error) {
      console.log(error);
    }
  }, []);

    const fetchProposals = useCallback(async () => {
        try {
            let response: any = await ProposalService.getRenuew();
            setRenuew(response.data)
        } catch (error) {
            console.log(error);
        }
    }, []);

  useEffect(() => {
    fetchProposals()
    getRenewSummary();
  }, [])

  return (
    <Card bordered={false} className="dashboard-card" bodyStyle={{ padding: 10 }}>
      <div className='dashboard-container'>
        <Row justify={'space-between'}>
          <div className='card-value'>
            {formatToTRY(reneuw?.total/counts?.total, false)} ₺
          </div>
          <img src={ArrowIcon} height={20} width={20} />
        </Row>
        <div>
          <Title style={{ fontWeight: 'bold' }} className='mb-0' level={3}>Ortalama Kazanç</Title>
          <Text style={{ fontWeight: 300, fontSize: 18, color: '#001433' }} className="m-0">Sözleşme Başı Son 6 Ay</Text>
        </div>
      </div>
    </Card>
  )
}

export default EarningsPerTransactionCard